import React from "react";
import Icons from "../../assets/icons.svg";
import PropTypes from "prop-types";

const Icon = ({ type, size }) => (
  <svg className={`icon icon-${type}`} width={size} height={size}>
    <use xlinkHref={`${Icons}#icon-${type}`} />
  </svg>
);

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default Icon;
